/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { clickTracker, getSourceValue, getSubEventType, helpfulObjData } from '../../../lib/common';
import { onClickEvent } from '../../../lib/gaAnalytics';
import styles from '../../../styles/Accordion.module.scss';
import styles2 from '../../Leads/TrackCompetitors.module.scss';
import { GetGenioFaqs, getStatistics, checkNoLeads } from '../../../api';
import { DataShimmer, FaqTicketCreate, Helpfull, Shimmer } from '../../common';
import ContractHealth from '../../Leads/ContractHealth';

const GenioLeadsFaq = () => {
  const [loading, setLoading] = useState(false);
  const [faqData, setFaqData] = useState([]);
  const [faqResponse, setFaqResponse] = useState([]);
  const [searchQuestion, setSearchQuestion] = useState('');
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [showMore, setShowMore] = useState(true);
  const [showAns, setShowAns] = useState(false);
  const [setActive, setActiveState] = useState('');
  const [showData, setShowData] = useState(true);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [helpful, setHelpful] = useState(helpfulObjData && helpfulObjData);
  const [selectedFaqData, setSelectedFaqData] = useState({});
  const [updateAns, setUpdateAns] = useState('');
  const [statisticsLoading, setStatisticsLoading] = useState(false);
  const [statisticsData, setStatisticsData] = useState({});
  const [faqsFeedbackData, setFaqsFeedbackData] = useState({});
  const [displayAlert, setDisplayAlert] = useState(false);
  const [leadDetails, setLeadDetails] = useState({});
  const source = getSourceValue();
  const navigate = useNavigate();
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));

  let searchQid = '';
  searchQid = localStorage.getItem('searchQid');

  useEffect(() => {
    const storedFeedbackData = sessionStorage.getItem('faqsFeedback');
    if (storedFeedbackData) {
      setFaqsFeedbackData(JSON.parse(sessionStorage.getItem('faqsFeedback')));
    }
  }, []);

  const handleSearchFaq = (e) => {
    setSelectedQuestionId(null);
    setSearchQuestion(e.target.value);
    const filteredFaqData =
      faqResponse && faqResponse.filter((each) => each.question.toLowerCase().includes(e.target.value.toLowerCase()));
    setFaqData(filteredFaqData);
  };

  const handleFaqClick = async (data, index) => {
    setShowData(true);
    setActiveIndex(index === activeIndex ? -1 : index);
    setHelpful(helpfulObjData && helpfulObjData);
    setSelectedFaqData(data);
    setSelectedQuestionId(selectedQuestionId === index ? null : index);
    setShowAns(selectedQuestionId !== index);
    setActiveState(setActive === '' || selectedQuestionId !== index ? `${styles.Active}` : ``);

    if (selectedQuestionId !== index) {
      if (data?.type === 'APICALL') {
        try {
          setStatisticsLoading(true);
          const params = {
            pid: selectedBusinessGenio?.parentId || '',
            city: selectedBusinessGenio?.city || '',
            type: data?.apiKey || '',
            source,
            projectId: 'genio',
          };
          const res = await getStatistics(params);
          if (res && res.errorCode === 0) {
            setStatisticsData(res?.result || {});
          }
          setStatisticsLoading(false);
        } catch (e) {
          console.log('error in getStatistics', e);
        }
      }

      await clickTracker(getSubEventType[data?.id] || '', 'leads_FAQ');
    }

    const updatedAns = data?.ans?.replace(
      '<videoURL>',
      `<div style="display: flex;justify-content: center;margin-right:15px;margin-top:10px;"><iframe title="videoUrl" allowFullScreen src=https://www.youtube.com/embed/${data?.videoUrl}> </iframe></div>`,
    );
    setUpdateAns(updatedAns);
  };

  const handleSearch = (paramsData) => {
    const data = paramsData;
    data?.forEach((ele, i) => {
      if (ele?.id?.toString() === searchQid) {
        data?.splice(i, 1);
        data?.unshift(ele);
      }
    });

    data?.forEach((faq, i) => {
      if (faq?.id?.toString() === searchQid) {
        handleFaqClick(faq, i);
      }
    });
    return data;
  };

  useEffect(() => {
    const handleGetGenioFaqs = async () => {
      try {
        setLoading(true);
        const paramsData = {
          key: 'leadsNew',
          parentId: selectedBusinessGenio.parentId || '',
          city: selectedBusinessGenio.city ? encodeURIComponent(selectedBusinessGenio.city) : '',
        };
        const res = await GetGenioFaqs(paramsData);
        if (res.errorCode === 0) {
          if (searchQid && searchQid !== '') {
            res.result = handleSearch(res.result);
          }
          setFaqData(res.result || []);
          setFaqResponse(res.result || []);
        }
        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    };
    handleGetGenioFaqs();
  }, []);

  const handleisHelpful = async (index, apiKey, faqId) => {
    if (apiKey === 'noLeads' && index === 1) {
      const noLeadsResp = await checkNoLeads(
        selectedBusinessGenio?.parentId || '',
        selectedBusinessGenio?.city || '',
        selectedBusinessGenio?.docId || '',
        selectedBusinessGenio?.city || '',
        selectedBusinessGenio?.docId || '',
        '',
        source,
      );
      if (noLeadsResp?.leadscount > 0 && noLeadsResp?.paidRemarks === '') {
        setDisplayAlert(true);
        setLeadDetails(noLeadsResp);
      }
    }
    setFaqsFeedbackData((prevData) => ({
      ...prevData,
      [faqId]: index === 0 ? 'Helpful' : 'NotHelpful',
    }));

    sessionStorage.setItem(
      'faqsFeedback',
      JSON.stringify({ ...faqsFeedbackData, [faqId]: index === 0 ? 'Helpful' : 'NotHelpful' }),
    );

    setHelpful((prevObj) =>
      prevObj.map((each) => (each.id === index ? { ...each, isActive: true } : { ...each, isActive: false })),
    );
    onClickEvent(
      `${`Leads-${apiKey}-${selectedBusinessGenio?.docId}`}`,
      `${`Leads-${apiKey}-${selectedBusinessGenio?.docId}`} ${helpful[index]?.val ? 'Helpful' : 'Not Helpful'}`,
      '',
    );

    await clickTracker(`${getSubEventType[faqId]}_${index === 0 ? 'yes' : 'no'}`, 'leads_FAQ_feedback');
  };

  const healthCheckObj = [
    {
      id: 0,
      icon: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/leaderboard_icon.svg',
      title: 'Run a health check on your leads',
      alt: 'healthCheck-icon',
    },
  ];

  const handleHealthCheck = async (id) => {
    if (id === 1) {
      window.location = `https://wap.justdial.com/analytics/competitortrend?docid=${
        selectedBusinessGenio?.docId || ''
      }&m=1&source=${source}&hide_header=1`;
    } else {
      navigate('/genio/leads/contract_health');
    }
    await clickTracker(
      id === 0 ? 'healthcheck_run' : 'competition_view',
      id === 0 ? 'leads_healthcheck' : 'leads_competition',
    );
  };

  const updatedFaqs = showMore ? (faqData && faqData.length > 0 ? faqData.slice(0, 4) : faqData) : faqData;
  return (
    <>
      <div className="p-20">
        {loading ? (
          <DataShimmer id="leadsfaq" />
        ) : (
          <>
            <div className="font16 fw700 color111 mb-15">Hi, how can we help you with your leads today?</div>
            <div className={`${styles.Accordion__Search}`}>
              <input
                className={`${styles.Accordion__Input} font12 fw500 color111`}
                type="text"
                placeholder="Search for keywords..."
                value={searchQuestion}
                onChange={handleSearchFaq}
              />
            </div>
            <div className={`${styles.Accordion__Box}`}>
              <div className="mt-10">
                {loading ? (
                  <Shimmer loading={loading} id="faq" />
                ) : (
                  <>
                    {updatedFaqs && updatedFaqs.length > 0 ? (
                      <>
                        {updatedFaqs &&
                          updatedFaqs.map((each, idx) => (
                            <div key={idx}>
                              <div
                                aria-label="genio_leads_faq"
                                tabIndex={0}
                                role="button"
                                onKeyDown={() => {}}
                                onClick={() => handleFaqClick(each, idx)}
                                className={`${styles.Accordion__Pannel__Heading} ${
                                  selectedQuestionId === idx && showAns ? setActive : ''
                                }`}
                              >
                                <div className={`${styles.Accordion__Pannel__Title} font13 fw500 color111`}>
                                  {each?.question || ''}
                                </div>
                                <div className={`${styles.Accordion__Pannel__Icon} csicon`} />
                              </div>
                              <div className={`${styles.Accordion__Contant}`}>
                                <div className={`${styles.Accordion__TextContant}`}>
                                  {showData ? (
                                    <>
                                      {each?.type !== 'APICALL' ? (
                                        <>
                                          {each?.videoUrl && each?.videoUrl !== '' ? (
                                            <div
                                              className="font12 fw400 color777 p-10"
                                              id="leads-faqs-list"
                                              dangerouslySetInnerHTML={{ __html: updateAns }}
                                            />
                                          ) : (
                                            <div
                                              className="font12 fw400 color777 p-10"
                                              id="leads-faqs-ans"
                                              dangerouslySetInnerHTML={{ __html: each?.ans }}
                                            />
                                          )}
                                        </>
                                      ) : each.type === 'APICALL' &&
                                        selectedQuestionId === idx &&
                                        statisticsData &&
                                        statisticsData?.healthCheck === 90 ? (
                                        statisticsLoading ? (
                                          <>
                                            <div className="loader-div">
                                              <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
                                            </div>
                                          </>
                                        ) : (
                                          <div
                                            className={`${styles.Accordion__ListItem} font12 fw400 color777 p-10`}
                                            dangerouslySetInnerHTML={{ __html: each?.ans }}
                                          />
                                        )
                                      ) : (
                                        selectedQuestionId === idx &&
                                        statisticsData &&
                                        statisticsData?.healthCheck !== 90 && (
                                          <ContractHealth
                                            id="faq"
                                            statisticsData={statisticsData}
                                            statisticsLoading={statisticsLoading}
                                            apiKey={each?.apiKey || ''}
                                            selectedFaqData={selectedFaqData}
                                            faqId={each?.id || null}
                                          />
                                        )
                                      )}
                                      {!statisticsLoading && (
                                        <>
                                          <div className={`${styles.Accordion__Helpful} mt-20 mb-10`}>
                                            <div className="font11 fw400 color777 mr-10">Was this Helpful?</div>
                                            {helpful &&
                                              helpful.map((item) => (
                                                // eslint-disable-next-line jsx-a11y/control-has-associated-label
                                                <div
                                                  onKeyDown={() => {}}
                                                  key={item.id}
                                                  role="button"
                                                  tabIndex={0}
                                                  onClick={() => {
                                                    handleisHelpful(item.id, each.apiKey, each.id);
                                                    setShowData(item.id === 0);
                                                  }}
                                                  className={`${item?.icon} ${
                                                    item?.isActive ||
                                                    (item.id === 0 && faqsFeedbackData[each.id] === 'Helpful') ||
                                                    (item.id === 1 && faqsFeedbackData[each.id] === 'NotHelpful')
                                                      ? styles.Active
                                                      : ''
                                                  } csicon mr-10`}
                                                />
                                              ))}
                                          </div>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {!statisticsLoading && (
                                        <>
                                          {helpful && helpful[1].isActive && (
                                            <div className="p-10">
                                              <FaqTicketCreate
                                                issue={each?.issue || ''}
                                                subIssue={each?.subIssue || ''}
                                                activeIndex={activeIndex}
                                                setShowData={setShowData}
                                                vertical="LISTING"
                                                category="CS"
                                                ticketCreator="BUSINESS"
                                                hideAlert
                                                hideCrossIcon={false}
                                                id="leads"
                                                faqId={each?.pop}
                                                faqObj={each}
                                                activeFaq={selectedFaqData?.apiKey}
                                                displayAlert={displayAlert}
                                                setDisplayAlert={setDisplayAlert}
                                                leadDetails={leadDetails}
                                              />
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                      </>
                    ) : (
                      <div className="no-data-div">No Data</div>
                    )}
                    <div className="text_center pt-10 pl-20 pr-20">
                      <button
                        type="button"
                        className={`${styles.viewMore__Btn}`}
                        onClick={async () => {
                          setShowMore((prev) => !prev);
                          setSelectedQuestionId(null);
                          await clickTracker(showMore ? 'viewmore' : 'viewless', 'leads_FAQ');
                        }}
                      >
                        {searchQuestion === '' && (showMore ? 'View More' : 'View Less')}
                      </button>
                    </div>
                    <div className="font16 fw700 color111 mb-15 mt-15">Leads Health Check</div>
                    <ul className={`${styles2.TrackCompetitors__itemlist}`}>
                      {healthCheckObj &&
                        healthCheckObj.map((each) => (
                          <li key={each.id} className={`${styles2.TrackCompetitors__item} whitefill_animate`}>
                            <div className={`${styles2.TrackCompetitors__imgbox}`}>
                              <img alt={each.alt} className={`${styles2.TrackCompetitors__image}`} src={each.icon} />
                            </div>
                            <div className={`${styles2.TrackCompetitors__textbox} font12 fw500 color111 mt-10`}>
                              {each?.title || ''}
                            </div>
                            <div>
                              <button
                                onClick={() => handleHealthCheck(each.id)}
                                className={`${styles2.HealthCheck__Btn} ${styles2.bluefill_animate} font10 fw-500 colorFFF mt-10`}
                                type="button"
                              >
                                Click Here
                              </button>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <Helpfull redirectkey="leads" />
    </>
  );
};

export default GenioLeadsFaq;
